import { useReferralCode } from '@src/hooks/useReferrals';
import {
  AnalyticsEvents,
  useAnalytics,
  useAnalyticsDefaultValues,
} from '@src/providers/analytics';
import toast from 'react-hot-toast';
import { BiCopy, BiGroup } from 'react-icons/bi';
import { Button, buttonVariants, Input, VStack } from 'ui_2';
import { CreateCustomCode } from './CreateCustomCode';

type ReferralCodeProps = {
  instructions?: string[];
  shareTitle?: string;
  shareText?: string;
  friendUsername?: boolean;
};

export const ReferralCode = ({
  instructions,
  shareTitle,
  shareText,
  friendUsername,
}: ReferralCodeProps) => {
  const { data: codeData } = useReferralCode();

  shareTitle =
    shareTitle ?? '🎁 Earn PARC + PART when you subscribe to Puzzle Pro!';
  shareText =
    shareText ??
    `🚀 Join me on Puzzle Pro and let's earn together!\n\nUse my referral code on signup: "${codeData?.referralCode}"`;

  const analytics = useAnalytics();
  const { address } = useAnalyticsDefaultValues();

  const onCopyClicked = () => {
    if (!codeData?.referralCode) {
      toast.error(`No ${friendUsername ? 'username' : 'referral code'} found!`);
      return;
    }
    navigator.clipboard.writeText(codeData.referralCode);
    toast.success(`Copied ${friendUsername ? 'username' : 'referral code'} !`);
  };

  return (
    <VStack className='gap-4'>
      <Input
        label={friendUsername ? undefined : 'Referral Code'}
        value={codeData?.referralCode}
        autoCapitalize='none'
        autoComplete='none'
        autoCorrect='none'
        disabled
        rightElement={
          <button onClick={onCopyClicked}>
            <BiCopy />
          </button>
        }
      />
      <CreateCustomCode
        currentCode={codeData?.referralCode}
        friendUsername={friendUsername}
        trigger={
          <div
            className={buttonVariants({
              variant: 'gray',
              size: 'md',
              className: 'w-full hover:cursor-pointer',
            })}
          >
            Create custom {friendUsername ? 'username' : 'referral code'}
          </div>
        }
      />
      <Button
        variant='primary'
        size='md'
        className='items-center gap-2'
        onClick={() => {
          void analytics.track(AnalyticsEvents.ReferralCodeShareClicked, {
            address,
            referralCode: codeData?.referralCode,
            offer: instructions?.join('. '),
          });
          navigator.share({
            title: shareTitle,
            text: shareText,
            url: 'https://app.puzzle.online',
          });
        }}
      >
        <BiGroup size={24} />
        Share with friends
      </Button>
    </VStack>
  );
};
